import { KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable'

/**
 * Sensores compartidos por toda la app: puntero **y teclado**.
 *
 * El de teclado no es un extra de accesibilidad. Es lo que permite mover la
 * tarea 7 al puesto 2 sin soltar el teclado (`Espacio` levanta, `↑/↓` mueven,
 * `Espacio` suelta, `Esc` cancela) y, de paso, lo que hace que los tests sean
 * deterministas: simular puntero con dnd-kit en jsdom depende de geometria real
 * y no prueba nada estable.
 *
 * `activationConstraint` de 4px en el puntero: sin eso, un click en el handle se
 * interpreta como el inicio de un arrastre y la fila "tiembla" al hacer foco.
 */
export function useDndSensors() {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  )
}
